import { useV2UpdateServiceAccountCredentialMutation } from "@generated";

interface UpdateInput {
  userId: number;
  credentialId: number;
  name: string;
  redirectUri?: string;
}

const useUpdateClientCredential = () => {
  const [trigger, { isLoading }] =
    useV2UpdateServiceAccountCredentialMutation();

  const updateCredential = async (input: UpdateInput): Promise<void> => {
    await trigger({
      userId: input.userId,
      id: input.credentialId,
      body: {
        data: {
          id: String(input.credentialId),
          type: "service-account-credentials",
          attributes: {
            name: input.name,
            "redirect-uri": input.redirectUri ?? "",
          },
        },
      },
    }).unwrap();
  };

  return { updateCredential, isUpdating: isLoading };
};

export default useUpdateClientCredential;
